import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import { Badge } from "../../../components/ui/badge";
import ClientProfile1 from "../../../modules/client/components/ClientProfile1";
import MyProfile from "../../../modules/professional/components/MyProfile";
import { RoleEnum } from "../../../modules/shared/model";

interface EditUserDetailModalProps {
  isOpen: boolean;
  onClose: () => void;
  user: any;
  onUserUpdated: () => void;
}

const EditUserDetailModal: React.FC<EditUserDetailModalProps> = ({
  isOpen,
  onClose,
  user,
  onUserUpdated
}) => {
  if (!isOpen || !user) return null;

  const getRoleLabel = (id: number) => {
    return RoleEnum[id];
  };

  const isClient = parseInt(user.role?.id) === RoleEnum.client || 
                   parseInt(user.role?.id) === RoleEnum.internationl_client;

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
        >
          <motion.div
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            exit={{ scale: 0.95 }}
            className="bg-white rounded-xl w-full max-w-7xl max-h-[95vh] overflow-hidden"
          >
            <div className="p-4 border-b bg-gray-50 flex items-center justify-between">
              <div className="flex items-center gap-3">
                <h2 className="text-xl font-semibold text-gray-900">
                  Edit User: {user.firstName} {user.lastName}
                </h2>
                <Badge variant="outline" className="text-sm">
                  {getRoleLabel(parseInt(user.role?.id))}
                </Badge>
              </div>
              <button
                onClick={onClose}
                className="p-2 hover:bg-gray-200 rounded-full transition-colors"
              >
                <X className="h-5 w-5 text-gray-500" />
              </button>
            </div>
            
            <div className="overflow-y-auto max-h-[calc(95vh-80px)]">
              {isClient ? (
                <ClientProfile1 
                  isAdminEdit={true}
                  adminUserId={user.id}
                  onUserUpdated={onUserUpdated}
                />
              ) : (
                <MyProfile 
                  isAdminEdit={true}
                  adminUserId={user.id}
                  onUserUpdated={onUserUpdated}
                />
              )}
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default EditUserDetailModal;
